import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LINKS } from '../../../../../Routs/config';
import { Surface, ScrollArea } from '../../../../../generic/ui/Surface';
import { Loader } from '../../../../../generic/ui/Loader';
import KnisotPageLayout from './KnisotPageLayout';
import KnisotSelectBar from './KnisotSelectBar';
import { CreateButton, CreateFab } from '../../../../../generic/ui/CreateButton';
import KnisotRowItem from './KnisotRowItem';
import { IEntrie } from '../../../../../modules/API/Knisot/models/entrie';
import { KnisotPrintHandler } from '../types';

interface Props {
    renderData: IEntrie[];
    isLoading: boolean;
    input: string;
    setInput: (v: string) => void;
    isAllowToCreate: boolean;
    prepareCreateEntry: () => void;
    handlePrintKnisa: KnisotPrintHandler;
    setDate: Dispatch<SetStateAction<string>>;
    setDateEnd: Dispatch<SetStateAction<string>>;
    handleDate: (e: object | object[]) => void;
    selectedDate: Date | Date[] | false;
    setDefaultDate: Date | Date[];
}

const KnisotListView: React.FC<Props> = ({
    renderData,
    isLoading,
    input,
    setInput,
    isAllowToCreate,
    prepareCreateEntry,
    handlePrintKnisa,
    setDate,
    setDateEnd,
    handleDate,
    selectedDate,
    setDefaultDate,
}) => {
    const [t] = useTranslation('knisa');
    const isEmpty = !renderData || renderData.length < 1;
    const lastIndex = (renderData?.length ?? 0) - 1;

    return (
        <KnisotPageLayout title={t('knisa_main_title')}>
            <BarRow>
                {isAllowToCreate && (
                    <CreateButton
                        to={LINKS.knisot.teudot.create}
                        label={t('knisa_main_button_new')}
                        onClick={prepareCreateEntry}
                    />
                )}
                <KnisotSelectBar
                    input={input}
                    setInput={setInput}
                    setDate={setDate}
                    setDateEnd={setDateEnd}
                    handleDate={handleDate}
                    selectedDate={selectedDate}
                    setDefaultDate={setDefaultDate}
                    placeholder={t('knisa_main_search_placeholder')}
                />
            </BarRow>
            <Surface>
                <ScrollArea>
                    {isLoading ? (
                        <CenterState>
                            <Loader size={56} />
                        </CenterState>
                    ) : isEmpty ? (
                        <EmptyState>
                            <img src='/images/no-data.png' alt='empty data' />
                        </EmptyState>
                    ) : (
                        renderData.map((entry, idx) => (
                            <KnisotRowItem
                                key={entry.EntryNum}
                                {...entry}
                                isLast={idx === lastIndex}
                                handlePrintKnisa={handlePrintKnisa}
                            />
                        ))
                    )}
                </ScrollArea>
            </Surface>
            {isAllowToCreate && (
                <CreateFab
                    to={LINKS.knisot.teudot.create}
                    label={t('knisa_main_button_new')}
                    onClick={prepareCreateEntry}
                />
            )}
        </KnisotPageLayout>
    );
};

export default KnisotListView;

const BarRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
`;

const EmptyState = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`;

const CenterState = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`;
